module.exports = "/fonts/Flaticon.ttf?3e4331ee31764c999add7e0b048c4ba3";